import * as React from 'react'

import type { ChangesByEmployee } from 'modules/employees/pages/EditInBulk/types'

interface Props {
  changes: ChangesByEmployee
}

const Context = React.createContext<ChangesByEmployee | null>(null)

export const LocalChangesByEmployeeProvider = ({
  children,
  changes,
}: React.PropsWithChildren<Props>) => {
  return <Context.Provider value={changes}>{children}</Context.Provider>
}

export const useLocalChangesByEmployee = (): ChangesByEmployee => {
  const values = React.useContext(Context)

  if (!values)
    throw new Error(
      'useLocalChangesByEmployee must be used within a LocalChangesByEmployeeProvider'
    )

  return values
}
